<template>
  <div class="modal-backdrop">
    <div class="modal">
      <section class="modal-body">
        <slot name="body">
          <div class="swiper-container swiper-container-2" ref="swiper">
            <div class="title-header" v-if="widget">
              <div>
                <router-link
                  :to="
                    slides[widget.activeIndex].path +
                    '/' +
                    slides[widget.activeIndex].id
                  "
                  @click.native="getAnotherItem"
                >
                  {{ slides[widget.activeIndex].title }}
                  {{ slides[widget.activeIndex].id }} ({{
                    widget.activeIndex + 1
                  }}/{{ slides.length }})
                </router-link>
              </div>
              <div>
                <button
                  type="button"
                  class="btn-close"
                  @click="closeFullScreen"
                >
                  x
                </button>
              </div>
            </div>
            <div class="swiper-wrapper">
              <div
                class="swiper-slide swiper-lazy"
                v-for="(slide, index) in slides"
                :key="index"
                :style="{
                  'background-image': 'url(' + slide.file_urls.fullsize + ')',
                }"
              ></div>
            </div>
            <div class="swiper-button-prev" @click="slidePrev"></div>
            <div class="swiper-button-next" @click="slideNext"></div>
          </div>
        </slot>
      </section>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main.js";

export default {
  name: "ItemPlayerFullsize",
  props: ["item", "tags", "slides", "collection"],
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      widget: null,
    };
  },
  methods: {
    buildWidget() {
      this.widget = new Swiper(".swiper-container-2", {
        // options
        slidesPerView: "1",
        observer: true,
        centeredSlides: false,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        grabCursor: true,
        mousewheel: true,
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        on: {
          init: function () {
            $(".swiper-button-prev").addClass("hidden");
          },
          transitionEnd: function (s) {
            0 === s.activeIndex
              ? $(".swiper-button-prev").addClass("hidden")
              : $(".swiper-button-prev").removeClass("hidden"),
              1 === s.progress
                ? $(".swiper-button-next").addClass("hidden")
                : $(".swiper-button-next").removeClass("hidden");
          },
        },
      });
    },
    slidePrev() {
      this.widget.slidePrev();
    },
    slideNext() {
      this.widget.slideNext();
    },
    closeFullScreen() {
      eventBus.$emit("closeFullSize");
    },
    getAnotherItem() {
      eventBus.$emit("getAnotherItem");
    },
  },
  mounted: function () {
    this.buildWidget();
  },
  watch: {
    slides: function () {
      if (this.collection.items_count == this.slides.length) {
        this.loading = false;
        this.current_item = this.slides[0];
      }
    },
  },
};
</script>

<style scoped>
.swiper-slide,
.just-loading {
  height: 90vh;
  text-align: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.just-loading div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 10px;
  font-size: 2em;
}

.swiper-slide img {
  height: 100%;
  width: auto;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
  width: 100%;
  height: 100vh;
}

.modal {
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  opacity: 1;
  height: 100%;
  width: 100%;
  overflow-y: hidden;
}

.title-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.title-header:first-child {
  padding-left: 15px;
}

.title-header:last-child {
  padding-right: 15px;
}

.modal-header,
.modal-footer {
  padding: 0px 15px 0px 15px;
  display: flex;
}

.modal-header {
  justify-content: space-between;
  margin: 0px;
}

.modal-footer {
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  margin: 0px;
  padding: 0px;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  background: transparent;
}

.btn-green {
  color: white;
  border-radius: 2px;
}

.swiper-button-next,
.swiper-button-prev {
  color: #c63;
}
.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemPlayer/ItemPlayerFullsize.vue